import { PropsWithChildren, ReactNode, memo } from 'react'

import { DialogProps as MuiDialogProps, Dialog as MuiDialog } from '@mui/material'

import { DialogTitle, DialogTitleProps } from '@shared/components/MaterialUIEnhancements'
import { DialogContext } from '@shared/components/MaterialUIEnhancements/Dialog'
import { DialogPaper } from '@shared/layouts'

type DialogProps = Omit<MuiDialogProps, 'children' | 'onClose'> & {
  title?: ReactNode
  onClose: (event?: unknown, reason?: 'backdropClick' | 'escapeKeyDown') => void
  DialogTitleProps?: DialogTitleProps
}

const DialogRaw = ({ children, title, onClose, DialogTitleProps, ...DialogProps }: PropsWithChildren<DialogProps>) => {
  return (
    <MuiDialog
      onClose={onClose}
      disableRestoreFocus
      {...DialogProps}
      slots={{ paper: DialogPaper, ...DialogProps.slots }}
      slotProps={{
        ...DialogProps.slotProps,
        paper: {
          elevation: 0,
          variant: 'outlined',
          ...DialogProps.slotProps?.paper,
        },
      }}
    >
      <DialogContext.Provider value={{ onClose }}>
        {title && (
          <DialogTitle onClose={onClose} {...DialogTitleProps}>
            {title}
          </DialogTitle>
        )}
        {children}
      </DialogContext.Provider>
    </MuiDialog>
  )
}

export const Dialog = memo(DialogRaw) as typeof DialogRaw
